function cookieValue(cookieName) {
    const cookies = decodeURIComponent(document.cookie).split('; ');
    for (let i = 0, len = cookies.length; i < len; i++) {
        if (cookies[i].indexOf(cookieName + '=') === 0) {
            return cookies[i].substring((cookieName + '=').length);
        }
    }

    return null;
}

function setCookieValue(cookieName, value, expiresDays) {
    const d = new Date();
    d.setTime(d.getTime() + (expiresDays * 24 * 60 * 60 * 1000));
    const expires = "expires=" + d.toUTCString();
    document.cookie = cookieName + '=' + value + ';' + expires + ';path=/';
}

function showLoader(cb) {
    $('#popupLoader').show();
    $('#popupFade').show();
    cb && cb()
}

function hideLoader(cb) {
    $('#popupLoader').hide();
    $('#popupFade').hide();
    cb && cb()
}

const debounce = (func, wait = 250) => {
    let timeout;
    return function(event) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func(event), wait);
    };
};

const scrollTo = (offset, speed = 500) => {
    const minScrollOffset = 5;
    const value = parseInt(offset, 10);
    if (value < minScrollOffset) {
        return;
    }

    window.site.htmlbody.animate({ scrollTop: value }, speed);
}

const getCssVar = (varName) => getComputedStyle(document.documentElement).getPropertyValue(`--${varName}`);
const breakpoints = {
    mobileLarge: parseInt(getCssVar('bpMobileLarge')),
    tablet: parseInt(getCssVar('bpTablet')),
    tabletMid: parseInt(getCssVar('bpTabletMid')),
    tabletLarge: parseInt(getCssVar('bpTabletLarge')),
    desktop: parseInt(getCssVar('bpDesktop')),
    large: parseInt(getCssVar('bpLarge')),
    exlarge: parseInt(getCssVar('bpExLarge')),
}

const navTopOffset = 50;

const lockout = {
    getScrollBarWidth: () => {
        const div = document.createElement('div');
        div.style.cssText = "overflow: auto scroll; width: 50px; height: 50px; position: absolute;";

        document.body.append(div);
        const scrollWidth = div.offsetWidth - div.clientWidth;

        div.remove();
        return scrollWidth;
    },
    setScrollbarWidthCssVar: () => document.documentElement.style.setProperty('--scrollbarWidth', `${lockout.getScrollBarWidth()}px`),
    on: (breakpoint) => {
        if (!breakpoint || (breakpoint && $(window).width() < breakpoints[breakpoint])) {
            window.site.html.addClass('lockout');
        }
    },
    off: () => window.site.html.removeClass('lockout'),
    toggle: () => window.site.html.toggleClass('lockout')
}
lockout.setScrollbarWidthCssVar();


// For this to work without the hassle of waiting for the elements to exist throught MutationObserver/etc make sure site.js is added to the end of <body>
// Also were not exporting this object as it would need importing to *every* file, must easier just to reference the window obj
window.site = {
    doc: $(document),
    body: $('body'),
    win: $(window),
    html: $('html'),
    htmlbody: $('html, body'),
}

export {
    breakpoints,
    cookieValue,
    hideLoader,
    lockout,
    debounce,
    scrollTo,
    setCookieValue,
    showLoader,
    navTopOffset
}
